var map = {
	"./43_banana.mp3": "5d18",
	"./44_pear.mp3": "141d",
	"./45_cherry.mp3": "b3d9",
	"./46_lemon.mp3": "05e4",
	"./47_pepper.mp3": "1bce",
	"./48_carrot.mp3": "adbb",
	"./49_tomato.mp3": "e995",
	"./click.mp3": "c957",
	"./empty_true.mp3": "56fb",
	"./false.mp3": "dc9c",
	"./true.mp3": "66b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f720";